




















import { Component, Vue } from 'vue-property-decorator';
import { firebase } from '../util/firebase';
import {Util} from "../util/Util";

@Component({
  components: {
  },
})
export default class StripePay extends Vue {

    protected stripeData: Object = {}

    protected stripeLoading: boolean = false

    protected price: number = 0

    protected contactId: string = '';

    protected engagementId: string = '';

    protected fullName: string = '';

    protected created() {
      (this as any).$analytics.logEvent("quote_requested");
      this.stripeLoading = true
      this.contactId = Util.of(sessionStorage.getItem("contactId"), '');
      this.engagementId = Util.of(sessionStorage.getItem("engagementId"), '');
      this.fullName = Util.of(sessionStorage.getItem("fullName"), '');
      firebase.firestore().collection('contacts').doc(this.contactId).collection('engagements').doc(this.engagementId).get().then(doc => {
          this.price = parseInt(doc.data().total_price.substring(1)) * 0.5;
          fetch("/createPaymentIntent", {
            method: "POST",
            headers: {
              "Content-Type": "application/json"
            },
            body: JSON.stringify({
              amount: this.price * 100
            })
          })
          .then(result => {
            return result.json();
          })
          .then(data => {
            //Set up credit card input elements
            let windowX: any = window;
            var stripe = windowX.Stripe(data.publishablekey);
            if (data.connectaccount && data.appfeepercentage) {
              stripe = windowX.Stripe(data.publishablekey, {stripeAccount: data.connectaccount});
            }
            var elements = stripe.elements();
            var card = elements.create("card", {
              style: {
                base: {
                  color: "#32325D",
                  fontWeight: 500,
                  fontFamily: "Inter UI, Open Sans, Segoe UI, sans-serif",
                  fontSize: "16px",
                  fontSmoothing: "antialiased",

                  "::placeholder": {
                    color: "#CFD7DF"
                  }
                },
                invalid: {
                  color: "#E25950"
                }
              }
            });
            card.mount("#card-element");

            this.stripeData = {
              stripe: stripe,
              card: card,
              clientSecret: data.clientSecret,
              id: data.id
            }

            this.stripeLoading = false
          })
      })
    }

    private payWithStripe() {
        this.stripeLoading = true
        let self: any = this;
        //Set up Pay button handler
        var data = {
          card: self.stripeData.card,
          billing_details: {
            name: self.fullName
          }
        };

        // Initiate the payment.
        // If authentication is required, confirmCardPayment will automatically display a modal

        // Use save_payment_method to indicate that you want to save the card
        // Use setup_future_usage to tell Stripe how you plan on charging the card
        self.stripeData.stripe
          .confirmCardPayment(self.stripeData.clientSecret, {
            payment_method: data,
            setup_future_usage: "off_session"
          })
          .then(result => {
            if(result.error){
              //error handling
              this.stripeLoading = false
            } else if(result.paymentIntent){
              // 将customerId保存在contact下
              fetch("/createCustomer", {
                method: "POST",
                headers: {
                  "Content-Type": "application/json"
                },
                body: JSON.stringify({
                  paymentMethod: result.paymentIntent.payment_method
                })
              })
              .then(result => {
                return result.json();
              })
              .then(data => {
                firebase.firestore().collection('contacts').doc(this.contactId).set({
                  customer_id: data.customerId
                }, {merge: true});
                this.stripeLoading = false
              })
              // 将paymentIntent保存在engagement下
              firebase.firestore().collection('contacts').doc(this.contactId).collection('engagements').doc(this.engagementId).get().then(response => {
                let pay_list:Array<any> = [];
                if (response.data().payment_intent_list) {
                  pay_list = response.data().payment_intent_list;
                }
                pay_list.push(result.paymentIntent);
                firebase.firestore().collection('contacts').doc(this.contactId).collection('engagements').doc(this.engagementId).set({
                  payment_intent_list: pay_list,
                  status: "DepositPaid"
                }, {merge: true}).then(response => {
                  this.$emit('paymentCompleted')
                })
              });
            }
          });
    }
}
